<template>
    <div>
        <ul class="nav nav-tabs" role="tablist">
            <li class="nav-item" v-for="c in $i18n.messages[$i18n.locale].tab.itemFormTabs" :key="c.id">
                <a :class="{'active': selectedTab == c.id}" class="nav-link" role="tab" @click="selectedTab = c.id">{{c.text}}</a>
            </li>
        </ul>
        <form @submit.prevent="submitForm">
            <div class="tab-content">
                <div :class="{'active': selectedTab == 'details'}" class="tab-pane mt-3">
                    <div class="form-group">
                        <label class="form-label">{{$t('label.title')}}</label>
                        <div class="input-group bg-white shadow-inset-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-transparent border-right-0">
                                    <i class="fas fa-text"></i>
                                </span>
                            </div>
                            <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.title')" v-model="title" required="">
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-sm-12 col-md-12">
                            <div class="form-group">
                                <label class="form-label">{{$t('label.price')}}</label>
                                <div class="input-group bg-white shadow-inset-2">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text bg-transparent border-right-0">
                                            <i class="fas fa-dollar-sign"></i>
                                        </span>
                                    </div>
                                    <input id="input-price" type="number" class="form-control bg-transparent pl-3" :placeholder="$t('label.price')" @keydown="isNumber($event)" v-model="price" required="">
                                </div>
                                <label v-if="priceError" for="input-price" class="error-class" style="" v-html="priceError"> </label>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 col-md-6 mb-2">
                            <div class="form-group">
                                <label class="form-label">{{$t('label.category')}}</label>
                                <div class="input-group">
                                    <div class="input-group-prepend w-100">
                                        <label class="input-group-text border-right-0">
                                            <i class="fas fa-tag"></i>
                                        </label>
                                        <multiselect 
                                            :value="selectedCategory" 
                                            :options="categories" 
                                            label="text" track-by="id" 
                                            :searchable="false" 
                                            :show-labels="false" 
                                            openDirection="below" 
                                            @select="filterSubCatByCategory">
                                        </multiselect>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6 mb-2">
                            <div class="form-group">
                                <label class="form-label">{{$t('label.subcategory')}}</label>
                                <div class="input-group">
                                    <div class="input-group-prepend w-100">
                                        <label class="input-group-text border-right-0">
                                            <i class="fas fa-tags"></i>
                                        </label>
                                        <multiselect 
                                            :value="selectedSubcategory" 
                                            :options="subCategory" 
                                            track-by="id" label="text" 
                                            :show-labels="false" 
                                            openDirection="below" 
                                            @select="selectSubcategory">
                                            <span slot="noResult">{{$t('table.no_records')}}</span>
                                        </multiselect>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group mt-3">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" id="editServiceEnable" v-model="enable">
                            <label class="custom-control-label" for="editServiceEnable">{{$t('label.enable')}}</label>
                        </div>
                    </div>
                </div>
                <div :class="{'active': selectedTab == 'policy'}" class="tab-pane mt-3">
                    <template>
                        <vue-editor v-model="content" />
                    </template>
                </div>
            </div>
            <div class="text-left border-top pt-3 mt-3 mb-3">
                <div class="row">
                    <div class="col-6">
                        <button v-if="!isEdit" type="button" class="btn border-0 btn-secondary btn-padding waves-effect waves-themed mr-3" @click="returnDiscountList">{{$t('button_link.cancel')}}</button>
                        <button :disabled="disableSave" type="submit" class="btn border-0 btn-primary btn-padding waves-effect waves-themed">{{$t('button_link.save')}}</button>
                    </div>
                    <div class="d-none col-6 text-right">
                        <button v-if="isEdit" type="button" class="btn border-0 btn-danger btn-padding waves-effect waves-themed" @click="deleteDiscount">Delete</button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
import { VueEditor } from "vue2-editor";
import {isNumber} from './../../../../assets/js/dashboard/utilities'
import {setCategoryLabel, getCategoryText, getSubcategory, handleSessionExpired} from './../../../../assets/js/dashboard/dashboard'
export default {
   name: 'discountForm',
   props:{
       isEdit: { type: Boolean },
       category: { type: Array },
   },
   components:{
       VueEditor
   },
   data(){
       return{
           type: "discount",
           selectedTab: "details",

           itemID: 0,
           title: "",
           price: '-',
           selectedCategory: {},
           enable: 1,

           categories: [],
           subCategories: [],
           subCategory: [],
           selectedSubcategory: {},
           content: "",

           priceError: '',
           disableSave: true,
       }
   },
    watch:{
        "$i18n.locale"(val){
            this.subCategory = this.setLabel(this.subCategories)
            
            var b = Object.assign({}, this.selectedSubcategory)
            this.selectedSubcategory = this.subCategory.filter(obj=> obj.id == b.id)[0]
        }
    },
   methods:{
       isNumber(e){
            setTimeout(this.validateNegative, 100)

            return isNumber(e);
        },
        setCategoryOptions(){
            this.categories = this.category.slice(1, this.category.length)
            this.selectedCategory = this.categories[0]
        },
        async filterSubCatByCategory(item){
            this.selectedCategory = item;
            var strFilter = "&category=" + item.id;
            this.subCategories = await getSubcategory(this, this.type, strFilter);

            this.subCategory = this.setLabel(this.subCategories)
            this.selectedSubcategory = this.subCategory[0]
        },
        selectSubcategory(item){
            this.selectedSubcategory  = {}
            this.selectedSubcategory = item;
        },
        returnDiscountList(){
            this.$emit('returnDiscountList');
        },
        async editDiscountForm(item, category){
            this.setCategoryOptions()
            await this.filterSubCatByCategory({id: item.category});
    
            this.itemID = item.itemID;
            this.title = item.title;
            this.price = item.price;
            this.selectedCategory = {id: item.category, text: getCategoryText(item.category, category)};
            this.selectedSubcategory = {id: item.folderID == "" ? "" : parseInt(item.folderID), text: item.folderID == "" ? this.$i18n.t('label.no_subCategory') : getCategoryText(item.folderID, this.subCategory)};
            this.enable = item.isEnable;
            this.priceError = ''
            this.disableSave = false

            var policy = await this.getItemPolicy(this.itemID)
            this.content = policy.policy
        },
        validateNegative() {
            this.disableSave = false
            this.priceError = ''

            if(parseFloat(this.price) > 0) {
                this.disableSave = true
                this.priceError = 'Discout price must be negative'
                return true
            }

            return false
        },
        submitForm(){
            if(this.validateNegative()) {
                return
            }

            var data = {
                type: this.type,
                title: this.title,
                category: this.selectedCategory.id,    
                price: this.price,
                folderID: this.selectedSubcategory.id == "" ? "" : this.selectedSubcategory.id,
                isEnable: this.enable ? 1 : 0
            }
            this.$emit('submitForm', data);
        },
        deleteDiscount(){
            this.$emit('deleteDiscount', this.itemID, this.title)
        },
        async getItemPolicy(id){
            let $vm = this;
            let QUERY_STRING =  "/" + id + this.$api.ITEM_POLICY
            const url =  this.$api.MENU_ITEM + QUERY_STRING;
            
            var result = []
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data.result[0]
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            return result;
        },
        async submitItemPolicy(){
            let $vm = this
            let QUERY_STRING =  "/" + this.itemID + this.$api.ITEM_POLICY
            const url =  this.$api.MENU_ITEM + QUERY_STRING;
            
            var status = false
            await this.$axios({
                method: 'post', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: this.$util.getSessionToken()},
                data: {
                    policy: this.content
                }
            })
            .then((response) => {
                if(response.status == 200){
                    status = true
                }
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            return status
        },
        setLabel(item){
            return setCategoryLabel(this, false, this.$i18n.t('label.no_subCategory'), item)
        },
    },
    async mounted(){
        let $vm = this;
        $vm.setCategoryOptions();
        
        $vm.subCategories = await getSubcategory($vm, $vm.type,"&category=0");
        $vm.subCategory = $vm.setLabel($vm.subCategories)
        $vm.selectedSubcategory = $vm.subCategory[0]
    }
}
</script>
<style scoped>
.nav-link, .link{
    cursor: pointer;
}
label.error-class {
    color: #cc5965;
    display: inline-block;
    margin-left: 5px;
}
</style>